var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72775 15.086C6.61309 15.8326 3.6905 17.3573 5.47055 19.2651C6.34009 20.1971 7.30854 20.8636 8.52611 20.8636H15.4738C16.6914 20.8636 17.6598 20.1971 18.5294 19.2651C20.3094 17.3573 17.3868 15.8326 16.2722 15.086C13.6583 13.335 10.3416 13.335 7.72775 15.086Z",
    stroke: "#070707",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5454 6.68182C15.5454 8.63992 13.9581 10.2273 12 10.2273C10.0419 10.2273 8.45451 8.63992 8.45451 6.68182C8.45451 4.72372 10.0419 3.13637 12 3.13637C13.9581 3.13637 15.5454 4.72372 15.5454 6.68182Z",
    stroke: "#070707",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6e5e9adee33ff5a27ccc57fc1aeb3e06.svg";
export { ForwardRef as ReactComponent };